import { render, staticRenderFns } from "./AccountSchool.vue?vue&type=template&id=6fedac69&scoped=true"
import script from "./AccountSchool.vue?vue&type=script&lang=js"
export * from "./AccountSchool.vue?vue&type=script&lang=js"
import style0 from "./AccountSchool.vue?vue&type=style&index=0&id=6fedac69&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fedac69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fedac69')) {
      api.createRecord('6fedac69', component.options)
    } else {
      api.reload('6fedac69', component.options)
    }
    module.hot.accept("./AccountSchool.vue?vue&type=template&id=6fedac69&scoped=true", function () {
      api.rerender('6fedac69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/AccountSchool.vue"
export default component.exports